import './Lector.css';
import React, { useState, useEffect } from "react";
import { QrReader } from "react-qr-reader";
import axios from "axios";
import { Button } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from "react-router-dom";
import { checkUserRole } from '../../hooks/customhooks';
import { useTranslation } from 'react-i18next';

const Lector = () => {
  const { t, i18n } = useTranslation('lector');
  const [startScan, setStartScan] = useState(true);
  const [loadingScan, setLoadingScan] = useState(false);
  const [data, setData] = useState(null);
  const [errorV, setErrorV] = useState('');
  const [errorLKey, setErrorLKey] = useState('');
  /*const [profileImage, setProfileImage] = useState(null);*/
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  useEffect(() => {
    const verifyrole = async () => {
      const okrole = await checkUserRole(2, token);

      if (!okrole) {
        navigate('/error');
      }
    };

    verifyrole();
  }, [navigate, token]);

  /*useEffect(() => {
    return () => {
      if (profileImage) {
        URL.revokeObjectURL(profileImage);
      }
    };
  }, [profileImage]);*/


  const handleScan = async (scanData) => {
    if (scanData) {
      setLoadingScan(true);
      try {
        const response = await axios.post('https://api.elplanmadrid.org/validarqr', { 'texto': String(scanData) });
        setData(response.data.res);

        // Hacer la solicitud para obtener la imagen directamente como blob
        /*const imageResponse = await axios.post('https://api.elplanmadrid.org/foto_admin', {
          token: token,
          usuario: response.data.res.userid
        }, { responseType: 'blob' }); // Especifica que esperas un blob en la respuesta*/

        // Convertir el blob en una URL válida para mostrar la imagen
        /*const imageUrl = URL.createObjectURL(imageResponse.data);

        // Guardar la URL de la imagen en el estado
        setProfileImage(imageUrl);*/

        setStartScan(false);
        setLoadingScan(false);
      } catch (error) {
        setStartScan(false);
        setLoadingScan(false);
        if (error.response) {
          switch (error.response.status) {
            case 404:
              setErrorLKey('entrada_no_encontrada');
              break;
            case 409:
              setErrorLKey('entrada_ya_validada');
              break;
            case 403:
              setErrorLKey('qr_no_valido');
              break;
            default:
              setErrorLKey('error_interno');
          }
        } else {
          setErrorLKey('error_interno');
        }
      }
    }
  };


  const handleError = (err) => {
    console.error(err);
  };

  const handleYes = async () => {
    try {
      await axios.post('https://api.elplanmadrid.org/aceptar', { "entrada": data.entrada_id, "token": token, "receptor": data.userid, "evento": data.evento_id });
      window.location.reload();
    } catch (error){
      if (error.response) {
        switch (error.response.status){
          case 401:
            setErrorV('token_expirado');
            break;
          case 403:
            setErrorV('no_autorizado');
            break;
          default:
            setErrorV('error_interno');
            break;
        }
      }
    }
  };

  const handleNo = () => {
    window.location.reload();
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
        timeZone: 'Europe/Madrid',  // Aseguramos la zona horaria de Madrid
        day: '2-digit',
        month: 'long',
        year: 'numeric'
    };
    return date.toLocaleString(i18n.language === 'es' ? 'es-ES' : 'en-US', options);
};


  return (
    <div className="lector-container">
      <div className="App container mt-5">
        {startScan && (
          <div className="d-flex justify-content-center mt-3">
            <div style={{ width: '300px', height: '300px', position: 'relative' }}>
              <h1 className='titulo mt-5'>{t('lector_qr')}</h1>
              <QrReader
                constraints={{ facingMode: "environment" }}
                delay={300}
                onResult={(result, error) => {
                  if (result) {
                    handleScan(result);
                  }
                  if (error) {
                    handleError(error);
                  }
                }}
                style={{ width: '100%', height: '100%' }}
              />
            </div>
          </div>
        )}
        {errorLKey && (
          <div className="msjerror text-center mt-5">
            <p className="text-danger">{t(errorLKey)}</p>
            <Button variant="danger" onClick={handleNo}>{t('refrescar')}</Button>
          </div>
        )}

        {data && (
          <div className="infoentrada text-center mt-3">
            <h1>{t('info')}</h1>

            {/* Mostrar la imagen de perfil 
            {profileImage ? (
              <img src={profileImage} alt="Profile" className="img-fluid rounded-circle mb-3" style={{ width: '150px', height: '150px' }} />
            ) : (
              <p>{t('sin_imagen')}</p> // Si no hay imagen, mostramos un mensaje opcional
            )}*/}

            <p><strong>{t('username')}:</strong> {data.username}</p>
            <p><strong>{t('telegram')}:</strong> {data.telegram}</p>
            <p><strong>{t('evento')}:</strong> {data.evento}</p>
            <p><strong>{t('fecha')}:</strong> {formatDate(data.fecha)}</p>
            <p><strong>{t('nacimiento')}:</strong> {formatDate(data.nacimiento)}</p>

            <div className="mt-3">
              <Button variant="success" onClick={handleYes}>{t('aceptar')}</Button>
              <Button className="ms-2" variant="danger" onClick={handleNo}>{t('rechazar')}</Button>
            </div>

            {errorV && <p className="text-danger">{t(errorV)}</p>}
          </div>
        )}
        {loadingScan && <p className="text-center">{t('loading')}</p>}
      </div>
    </div>
  );
};

export default Lector;
